import Axios from 'axios';
import { toast } from 'react-toastify';

const axios = Axios.create();

axios.interceptors.request.use(config => {
  if (config.url) {
    config.url = config.url.replace(/([^:]\/)\/+/g, "$1");
  }

  const token = `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ilg1ZVhrNHh5b2pORnVtMWtsMll0djhkbE5QNC1jNTdkTzZRR1RWQndhTmsifQ.eyJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vYjMxYTQzODYtNjczMi00MjFlLWI2YzEtODIzNmUxOGJhMzhjL3YyLjAvIiwiZXhwIjoxNTcxMjIwMjI5LCJuYmYiOjE1NzEyMTY2MjksImF1ZCI6IjczZDUzYmZjLTRiOWMtNDQ0OC05M2UxLTcxYzBjMGJmYTQ0ZiIsIm9pZCI6IjU1MGY2NjM2LWFlNmYtNDNmMi1hZjE4LWNiYzFkNzhkYWZmOSIsInN1YiI6IjU1MGY2NjM2LWFlNmYtNDNmMi1hZjE4LWNiYzFkNzhkYWZmOSIsImV4dGVuc2lvbl9Db21wYW55TmFtZSI6IkxOIiwibmFtZSI6IlNuZWhhIiwiZXh0ZW5zaW9uX0FncmVlZFRvVGVybXNBbmRDb25kaXRpb25zIjoidHJ1ZSIsImVtYWlscyI6WyJzbmVoYUBsb2dpc3RpY3Nub3cuaW4iXSwidGZwIjoiQjJDXzFfU2lnbl9VcF9TaWduX0luIiwibm9uY2UiOiI1MzI2MGQ1ZS0wODk4LTQ0ZTktOWM2Yy00ZmE2ZTI3NTYyZTEiLCJzY3AiOiJ1c2VyX2ltcGVyc29uYXRpb24iLCJhenAiOiI3M2Q1M2JmYy00YjljLTQ0NDgtOTNlMS03MWMwYzBiZmE0NGYiLCJ2ZXIiOiIxLjAiLCJpYXQiOjE1NzEyMTY2Mjl9.Z3OznNWpWUPpHwc4wcnmYqT3TlRUTy_6YiF8O53UIeHJbztK6YnqTJlBdNIrdqMrcVNCXWb5aIKg3sJ_VIgKNDTPqpqiAIrcCTn_9CurWw2m-5ojxOum5tRU_-8OxeNTrUn7L4nRB--kmq1F2C_9Rf5VIVyuC-af_yJTF55Hh-bsHZStkQ-su96imatn_C_fdQXzH9qV3uv9MBpwwKvD2Von3VpSiQw_UDcpOCdXbbrJunmW-xQhptGvBhSYK6n_EZu-YFVioBK1iwlNBwLeJTMzv7MMNUQUN5tL6KKvUOFRmuxSqma37tsMQJjn0t6vRhKCkYY9_2HFGZjzcqo-BA`;
  config.headers.Authorization = token;

  return config;
});

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    toast.info('Request failed. Please check your connection and retry!');
    return Promise.reject(error);
  }
);

export default axios;
